import { FormGroup } from 'react-bootstrap'
import styled from 'styled-components'

import { SwitchButton } from '../../../../../../../generic'

export const UpdateMode = styled.div`
    border-top: 1px solid;
    border-bottom: 1px solid;
    border-color: ${({ theme }) => theme['gray-500']};
    padding: 24px 0 24px 0;
    width: 100%;
    margin-bottom: 24px;

    .add-escalation-button {
        margin-top: 24px;
    }

    .new-rule-button {
        margin-bottom: 24px;
    }

    .escalations {
        padding-top: 16px;
    }

    .initial-pfd-formgroup {
        margin-top: 20px;
    }

    .validation-range-help-block {
        color: ${({ theme }) => theme['red-500']};
    }

    .validation-range-formgroup,
    .new-rule-formgroup {
        display: flex;
        justify-content: space-between;

        .validation-range-formgroup-labeltext,
        .new-rule-formgroup-labeltext {
            display: flex;
            flex-direction: column;
            margin-top: 8px;
        }

        .new-rule-formgroup-labeltext,
        .validation-range-formgroup-labeltext {
            width: 78px;
            .validation-label,
            .new-rule-labels {
                font-size: 13px;
                font-weight: 400;
                padding-bottom: 5px;
                line-height: 16px;
            }
        }
    }

    .validation-range-formgroup {
        justify-content: flex-start;
        gap: 5px;
        .units {
            padding-top: 35px;
            font-size: 13px;
            font-weight: 400;
            line-height: 16px;
        }
    }

    .new-rules-formgroups {
        margin-top: 20px;
    }

    .equals {
        padding-top: 32px;
        span {
            font-weight: 900;
        }
    }

    .radio-container {
        padding-top: 32px;
        padding-bottom: 16px;
        display: flex;
        gap: 10px;
        input[type='radio'] {
            border-radius: 50%;
        }

        label {
            font-family: 'SourceSansPro-Regular';
            padding-bottom: 2px;
            font-size: 13px;
            font-weight: 400;
            line-height: 16px;
        }
    }

    .rules-trash {
        color: ${({ theme }) => theme['red-500']};
        cursor: pointer;
        padding-top: 37px;
        padding-right: 10px;
    }
    .disabled {
        color: ${({ theme }) => theme['gray-500']};
        cursor: default;
    }
`
export const Escalations = styled.div`
    width: 100%;
    display: flex;
    .form-group {
        width: 100%;
        margin: 0;
        padding-top: 24px;
    }

    .escalationfactor-ic-box {
        padding-left: 8px;
        width: 80px;
    }
    textarea {
        border-radius: 3px;
        overflow: auto;
        outline: none;

        -webkit-box-shadow: none;
        -moz-box-shadow: none;
        box-shadow: none;

        resize: none;
    }
`

export const RemoveEscalation = styled.div`
    padding-top: 24px;
    width: 24px;
    height: 24px;
    button {
        width: 24px;
        height: 24px;
        padding: 0;
        background: transparent;
        border: none;
        color: ${({ theme }) => theme['red-500']};
    }
`

export const Manual = styled.div`
    padding-top: 24px;
    .react-datepicker__navigation--next {
        color: #37a3ef;
        width: 16px;
        height: 10px;
        padding: 0;
        max-width: 0ch;
        overflow: hidden;
        padding-right: 5px;
        background: transparent;
        border-left-color: ${({ theme }) => theme['blue-500']} !important;
    }

    .react-datepicker__navigation--previous {
        color: ${({ theme }) => theme['blue-500']} !important;
        width: 16px;
        height: 10px;
        padding: 0;
        max-width: 0ch;
        overflow: hidden;
        padding-left: 5px;
        background: transparent;
        border-right-color: ${({ theme }) => theme['blue-500']} !important;
    }
    .react-datepicker__current-month {
        text-transform: capitalize;
        padding-bottom: 16px;
        font-size: 16px;
        font-weight: 600;
    }
    .react-datepicker__header {
        background: transparent;
        border: none;
    }
    .react-datepicker {
        /* border: none; */
        background: transparent;
    }

    .react-datepicker__month {
        width: 302px;
    }

    .react-datepicker__day,
    .react-datepicker__day-name {
        color: ${({ theme }) => theme['gray-700']} !important;
        width: 3.1em !important;
        line-height: 2em !important;
    }

    .react-datepicker__current-month {
        color: ${({ theme }) => theme['gray-800']} !important;
    }

    .react-datepicker__day--outside-month {
        color: ${({ theme }) => theme['gray-500']} !important;
    }

    .react-datepicker__day:hover {
        background-color: ${({ theme }) => theme['gray-300']} !important;
        color: ${({ theme }) => theme['gray-900']} !important;
    }

    .react-datepicker__day--selected {
        background-color: ${({ theme }) => theme['blue-300']} !important;
        color: ${({ theme }) => theme['gray-900']} !important;
        font-weight: 600;
    }

    input[type='checkbox'] {
        border-radius: 50% !important;
    }

    /* .react-datepicker__day--sun,
    .react-datepicker__day--mon,
    .react-datepicker__day--tue,
    .react-datepicker__day--wed,
    .react-datepicker__day--thu,
    .react-datepicker__day--fri,
    .react-datepicker__day--sat {
        padding: 5px 10px;
    } */
`

export const EvidencesSwitchButton = styled(SwitchButton)`
    padding-bottom: 100px;
`

export const FormField = styled(FormGroup)`
    .Select-control {
        #barrierEditor-barrierEditModal-field-barrierType,
        #barrierEditor-barrierEditModal-field-criticality,
        #barrierEditor-barrierEditModal-field-updateMode {
            height: 34px;
            margin: 0px;
            padding: 0px;
        }
    }
`

export const RelatedLinks = styled.div`
    border-top: 1px solid;
    border-bottom: 1px solid;
    border-color: ${({ theme }) => theme['gray-500']};
    margin-top: 24px;
    padding: 24px 0 24px 0;

    .link-set::first {
        margin-top: 24px;
    }

    .link-set {
        display: flex;
        gap: 8px;
        margin-top: 24px;
        textarea {
            border-radius: 3px;
            overflow: hidden;
            outline: none;

            -webkit-box-shadow: none;
            -moz-box-shadow: none;
            box-shadow: none;

            resize: none;
        }

        .url-textarea {
            overflow: auto;
        }
        .form-group {
            margin-bottom: 0;
        }
    }

    .link-icon > i {
        margin-top: 1.2em;
        color: var(--blue-500);
        font-size: 16px;
        cursor: pointer;

        &:not(:last-child) {
            margin-right: 6px;
        }

        &.fa-trash {
            color: var(--red-700);
        }

        &.fa-trash-alt {
            color: var(--red-700);
        }
    }

    .new-link-button {
        margin-top: 24px;
    }
`
export const ManualInteractionWrapper = styled.div`
    padding-top: 24px;
`
